enum BookingItemType {
  DEFINED = 2,
  KOR = 6,
}

export default BookingItemType;
